import React from "react";
import DashboardTitle from "../DashboardTitle/DashboardTitle";
import Graph from "../../../Shared/Svgs/Graph";
import KeyMetric from "./KeyMetric/KeyMetric";
import useStore from "../../../../../js/state/state";

const KeyMetrics = () => {
    const { metrics } = useStore();

    return (
        <div className="KeyMetrics">
            <DashboardTitle
                title="Key Metrics"
                svg={<Graph />}
            />
            <div className="keyMetricsContainer">
                {metrics.map((metric, index) => (
                    <KeyMetric
                        key={index}
                        title={metric.title}
                        value={metric.value}
                        change={metric.change}
                        isUp={metric.isUp}
                    />
                ))}
            </div>
        </div>
    );
};

export default KeyMetrics;
